import { useLocale } from 'next-intl';
import { convertCultureToRef } from '@/utils/common-util';
import { CdnImg } from '@/features/cdn-img';
import { Button } from '@nf/ui';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

const supportLanguages = ['id', 'vn', 'ch', 'th', 'cs', 'zhcn'];

interface SbrSliderProps {
	onClose: () => void;
}

export const SbrSlider = ({ onClose }: SbrSliderProps) => {
	const locale = useLocale();
	const router = useRouter();
	const t = useTranslations('General');
	const shortLang = convertCultureToRef(locale ?? 'en-US');
	const lang = supportLanguages.includes(shortLang) ? shortLang === 'zhcn' ? 'cs' : shortLang : 'en';

	const handleClickButton = () => {
		onClose();
		router.push('/promotion?tab=popular');
	}

	return (
		<div className="sbr-slider">
			<div className="sbr-slider__img">
				<CdnImg
					src={`/images/promotion-activity-modal/sbr-slider/${lang}.png`}
					alt=""
					width={288}
					height={360}
					isGalaxyFolder={true}
				/>
			</div>
			<div className="sbr-slider__content">
				<div className="sbr-slider__title">
					{t('lbl_SBRPopup01')} <br />
					{t('lbl_SBRPopup02')}
				</div>
				<div className="sbr-slider__desc">
					{t('lbl_SBRPopup03')} <br />
					{t('lbl_SBRPopup04')}
				</div>
				<div className="sbr-slider__btn">
					<Button
						variant="classic"
						onClick={handleClickButton}
					>
						{t('lbl_GalaxyTryNow1')}
					</Button>
				</div>
			</div>
		</div>
	)
}